import { Stack } from '@mui/material';
import { ReactElement } from 'react';

import { CreditCard, Plan } from '@localstack/types';

import { TaxElement } from './TaxElement';

import { PaymentElement } from './PaymentElement';

import { AddressElement } from './AddressElement';

interface CheckoutFormProps {
  requiresPayment?: boolean;
  showCardForm?: boolean;
  plan: Plan;
  card: Optional<CreditCard>;
  setCard: (card: CreditCard) => void;
  filteredCards: CreditCard[];
  onDeleteCard: ((card: CreditCard) => unknown) | undefined;
  renderCardForm?: (currency: string) => ReactElement;
  onToggleCardForm?: () => void;
}

export const CheckoutForm = ({
  requiresPayment,
  showCardForm,
  plan,
  card,
  setCard,
  filteredCards,
  onDeleteCard,
  renderCardForm,
  onToggleCardForm,
}: CheckoutFormProps): ReactElement => {
  return (
    <Stack spacing={3}>
      <AddressElement isNotPriceless={!!requiresPayment} />
      <TaxElement requiresPayment={!!requiresPayment} />
      <PaymentElement
        isCardRequired={!!requiresPayment}
        showCardForm={!!showCardForm}
        filteredCards={filteredCards}
        card={card}
        setCard={setCard}
        onDeleteCard={onDeleteCard}
        renderCardForm={renderCardForm}
        plan={plan}
        onToggleCardForm={onToggleCardForm}
      />
    </Stack>
  );
};
